// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23zJ_","rootNoMargin":"styles_rootNoMargin__3Vjho"};